module.exports = __webpack_public_path__ + "static/media/travel_icon.34936672.svg";